import { NavLink, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthProvider";
import { History } from "./pages/History";
import { Login } from "./pages/Login";
import { ReviewQueue } from "./pages/ReviewQueue";
import { TestBench } from "./pages/TestBench";

const tabClass = ({ isActive }: { isActive: boolean }): string => (isActive ? "tab active" : "tab");

export function App() {
  const { authed, email, logout } = useAuth();
  if (!authed) return <Login />;
  return (
    <div className="page">
      <header className="topbar">
        <span className="brandmark">
          <svg className="hallmark" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 2.5L21.5 12 12 21.5 2.5 12z" stroke="#1b1a17" strokeWidth="1.6" />
            <path d="M12 7.5L16.5 12 12 16.5 7.5 12z" fill="#a9822f" />
          </svg>
          <strong>Ring Swap</strong>
        </span>
        <nav className="tabs">
          <NavLink to="/" end className={tabClass}>
            Review Queue
          </NavLink>
          <NavLink to="/bench" className={tabClass}>
            Test Bench
          </NavLink>
          <NavLink to="/history" className={tabClass}>
            History
          </NavLink>
        </nav>
        <span className="spacer" />
        <span className="muted">{email}</span>
        <button className="btn ghost" onClick={logout}>
          Sign out
        </button>
      </header>
      <Routes>
        <Route path="/" element={<ReviewQueue />} />
        <Route path="/bench" element={<TestBench />} />
        <Route path="/history" element={<History />} />
      </Routes>
    </div>
  );
}
